<template>
	<div class="integrations">
		<ul class="integration-list">
			<li
				class="integration-list__item"
				v-for="item in items"
				:key="item.thirdPartyId"
				data-test="thirdPartyList"
			>
				<ThirdPartyCard
					:id="`${uid}_${item.thirdPartyId}_card`"
					:source="item"
					v-on="$listeners"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import ThirdPartyCard from './thirdparties-card.vue';

export default {
	name: 'ThirdPartyList',
	components: {
		ThirdPartyCard
	},
	props: {
		items: Array
	}
};
</script>

<style lang="scss" scoped>
/**
    * Results List
*/

.integrations {
	&__item {
		margin-bottom: $gutter-lg;
	}
}

.integration-list {
	list-style: none;
	padding: 0;
	overflow-y: auto;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
	grid-template-rows: auto;
	gap: 12px;
	align-content: start;
}

/*------------------------------------*\
  #BASE DESKTOP-UP
\*------------------------------------*/
@include mq($from: lg) {
	.integration-list {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
